import { styled } from 'next-yak'

export const Buttons = styled.div`
  display: flex;
  justify-content: end;
`
